import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInitialStatePermissions } from "../types";
import { IRolesPayload } from "@pages/Administration/Role/components/RolePages/Roles/types";
import { IRoleGroupsPayload } from "@pages/Administration/Role/components/RolePages/RoleGroups/types";
import { IEntityWithIDTranslations, ITranslation } from "../../../../types";

const initialState: IInitialStatePermissions = {
    permissions: [],
    permissionsModule: [],
    permissionsTypeData: [],
    permissionTypeRole: "",
    permissionsSelectedRoleID: 0,
    permissionSelectedModules: [],
    permissionsAccess: {},
};

const permissionsSlice = createSlice({
    name: "permissions",
    initialState,
    reducers: {
        setPermissions: (state, action) => {
            state.permissions = action.payload;
        },
        setPermissionsModule: (state, action) => {
            state.permissionsModule = action.payload;
        },
        setPermissionTypeRole: (state, action) => {
            state.permissionTypeRole = action.payload;
        },
        setPermissionsTypeData: (
            state,
            action: PayloadAction<{
                defaultLanguage: string;
                res: (IRolesPayload | IRoleGroupsPayload)[];
            }>
        ) => {
            const { defaultLanguage, res } = action.payload;

            const translatableRes = res as IEntityWithIDTranslations[];

            state.permissionsTypeData = translatableRes
                .filter(elem => elem.translations.some(translation => translation.slug === defaultLanguage))
                .map(elem => {
                    const translation = elem.translations.find(item => item.slug === defaultLanguage);

                    return {
                        id: Number(elem.id),
                        name: translation?.name ?? "",
                    };
                });
        },

        setPermissionSelectedRoleID: (state, action) => {
            state.permissionsSelectedRoleID = action.payload;
        },
        setPermissionSelectedModules: (state, action) => {
            state.permissionSelectedModules = action.payload;
        },
        setPermissionsFrontendFormat: (state, action) => {
            if (Array.isArray(action.payload.permissions)) {
                state.permissionsAccess = {};
            } else {
                state.permissionsAccess = action.payload.permissions;
            }
        },
    },
});

export const {
    setPermissions,
    setPermissionsModule,
    setPermissionsTypeData,
    setPermissionTypeRole,
    setPermissionSelectedRoleID,
    setPermissionSelectedModules,
    setPermissionsFrontendFormat,
} = permissionsSlice.actions;

export default permissionsSlice;
